<p *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title" class="custom-title">
    {{ title }}
</p>
<span *ngIf="message && !options.enableHtml" role="alert" aria-live="polite" class="toast-message lh-25" [class]="options.messageClass" [attr.aria-label]="message">
    {{ message | translate }}

    <button type="button" class="btn button btn-primary float-end" (click)="action($event)">
        {{'common.cookie_consent_ok' | translate }}
    </button>
</span>
